/**
 * Визуальные константы DM-интерфейса, перенесённые из кликабельного макета
 * «Vellin Messenger». Держим их в одном месте, чтобы не дублировать длинные
 * градиенты/тени по компонентам списка диалогов, ленты, голосовых и композера.
 *
 * Фирменный слой (коралловый градиент, тени, радиусы пузырей) задаём напрямую —
 * он одинаков в любой теме. Поверхности (фон ленты, входящие пузыри, стекло)
 * берём из токенов через inline-стили на местах, чтобы светлая тема не ломалась.
 */

/** Градиент исходящих пузырей и крупных акцентных кнопок (отправка, бейдж). */
export const ACCENT_GRAD = 'linear-gradient(155deg,#FF5A4D,#F12D3E 56%,#D5102E)';
/** Градиент круглых кнопок (микрофон, «написать», отправить голосовое). */
export const ACCENT_GRAD_BTN = 'linear-gradient(155deg,#FF5A4D,#D5102E)';

/** Тень исходящего пузыря: мягкое цветное свечение + верхний внутренний блик. */
export const OUT_SHADOW = '0 10px 24px -8px rgba(225,30,55,0.5), inset 0 1px 0 rgba(255,255,255,0.22)';
/** Свечение под круглыми акцентными кнопками. */
export const BTN_GLOW = '0 8px 20px -6px rgba(225,30,55,0.6)';

/** Скругления пузырей с «хвостом» (как в макете): входящий слева, исходящий справа. */
export const R_BUBBLE_IN = '20px 20px 20px 7px';
export const R_BUBBLE_OUT = '20px 20px 7px 20px';

/** Акцентные оттенки текста (статус «в сети», активные элементы). */
export const ACCENT_TEXT = '#FF6B5E';
export const ACCENT_TEXT_SOFT = '#FF7A6E';

/** Цвет времени/галочек на исходящем градиенте. */
export const ON_ACCENT_DIM = 'rgba(255,255,255,0.75)';
